<template>
  <div class="field-control">
    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-comments"></i> 文字场控功能</h2>
        <div class="header-actions">
          <button class="btn btn-success" @click="addCommand">+ 添加场控内容</button>
          <button class="btn btn-import" @click="importCommands">导入</button>
          <button class="btn btn-export" @click="exportCommands">导出</button>
          <button class="btn btn-danger" @click="clearCommands">清空</button>
          <button
              class="btn btn-field-control"
              :class="{ 'btn-field-control-active':$store.state.textStatus }"
              @click="toggleFieldControl"
          >
            {{ $store.state.textStatus ? '停止文字场控' : '开始文字场控' }}
          </button>
        </div>
      </div>

      <div class="control-settings">
        <div class="setting-row">
          <div class="setting-item">
            <label>场控组</label>
            <div class="custom-select" @click="toggleGroupDropdown">
              <div class="custom-select-value">
                {{ getSelectedGroupName }}
              </div>
              <i class="fas fa-chevron-down select-arrow"></i>
              <div v-if="showGroupDropdown" class="custom-select-dropdown">
                <div
                    class="dropdown-item"
                    :class="{ selected: config.group_id == 0 }"
                    @click="selectGroup(0)"
                >
                  默认场控组
                </div>
                <div
                    v-for="group in groups"
                    :key="group.id"
                    class="dropdown-item group-item"
                    :class="{ selected: config.group_id === group.id }"
                    @click.stop="selectGroup(group.id)"
                >
                  <span>{{ group.name }}</span>
                  <button
                      class="delete-group-btn"
                      @click.stop="deleteGroup(group.id)"
                      title="删除此场控组"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
            <button class="btn btn-sm btn-secondary" @click="showImageModal = true">+ 新增</button>
          </div>

          <div class="setting-item">
            <label>场控顺序</label>
            <select v-model="config.control_order" class="setting-select" @change="updateConfig">
              <option value="0">正常顺序</option>
              <option value="1">随机顺序</option>
            </select>
          </div>

          <div class="setting-item">
            <label>发言频率</label>
            <div class="frequency-control">
              <input type="number" v-model.number="config.send_freq_min" class="frequency-input" min="1" max="300"
                     @change="updateConfig">
              <span class="frequency-separator">~</span>
              <input type="number" v-model.number="config.send_freq_max" class="frequency-input" min="1" max="300"
                     @change="updateConfig">
              <span class="frequency-unit">秒</span>
            </div>
          </div>

          <div class="checkbox-group">
            <label class="checkbox-item">
              <input type="checkbox" v-model="config.rand_space" @change="updateConfig">
              <span class="checkbox-custom"></span>
              <span>随机空格</span>
            </label>

          </div>
        </div>

      </div>

      <div class="commands-list">
        <div class="list-header">

          <div class="header-command">序号</div>
          <div class="header-content">场控内容</div>
          <div class="header-actions">操作</div>
        </div>

        <div v-if="commands?.list?.length === 0" class="empty-state">
          <i class="fas fa-inbox"></i>
          <p>暂无场控内容</p>
        </div>

        <div v-for="(command, index) in commands?.list" :key="command.id" class="command-item">

          <div class="item-command">{{ (queryForm.page - 1) * queryForm.limit + index + 1 }}</div>
          <div class="item-content">{{ command.content }}</div>
          <div class="item-actions">
            <button class="btn-action edit" @click="editCommand(command)"><i class="fas fa-edit"></i></button>
            <button class="btn-action delete" @click="deleteCommand(command.id)"><i class="fas fa-trash"></i></button>
          </div>
        </div>
      </div>


      <div class="pagination-container">
        <div class="pagination">
          <button class="page-btn" @click="previousPage" :disabled="queryForm.page === 1">
            <i class="fas fa-chevron-left"></i>
          </button>
          <div class="page-info">
            第 {{ queryForm.page }} 页，共 {{ queryForm.pageCount }} 页
          </div>
          <button class="page-btn" @click="nextPage" :disabled="queryForm.page >= queryForm.pageCount">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- 添加/编辑指令弹窗 -->
    <div class="modal" v-if="showCommandModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingCommand ? '编辑场控内容' : '添加场控内容' }}</h3>
          <button class="close-modal" @click="showCommandModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>场控内容</label>
            <textarea v-model="currentCommand.content" placeholder="请输入场控内容，建议不要超过45字" class="form-textarea no-resize"
                      rows="1" maxlength="50"></textarea>
          </div>
          <div class="variable-section">
            <label>变量内容</label>
            <textarea v-model="variableContent" class="form-textarea variable-display" rows="4"></textarea>
            <div class="variable-tools">
              <button type="button" class="btn btn-variable-main" @click="applyVariables">
                <i class="fas fa-robot"></i> 一键变量洗稿
              </button>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="showCommandModal = false">取消</button>
          <button class="btn btn-primary" @click="saveCommand">保存</button>
        </div>
      </div>
    </div>

    <!-- 图片功能弹窗 -->
    <div class="modal" v-if="showImageModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>新增场控组</h3>
          <button class="close-modal" @click="showImageModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>场控组名称</label>
            <input type="text" v-model="newGroupName" placeholder="请输入场控组名称" class="form-input">
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="showImageModal = false">取消</button>
          <button class="btn btn-primary" @click="saveGroupWithImage">保存</button>
        </div>
      </div>
    </div>

    <!-- 变量选择弹窗 -->
    <div class="modal" v-if="showVariableModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>智能变量洗稿</h3>
          <button class="close-modal" @click="showVariableModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="variable-list">
            <button type="button" class="btn btn-variable-item" v-for="v in variables" :key="v"
                    @click="insertVariableFromModal(v)">{{ v }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import {delay, getRandomInt} from "@/utils/function";
import {chat} from "@/utils/Ai";

export default {
  name: 'FieldControl',
  data() {
    return {
      queryForm: {
        group_id: 0,
        limit: 4,
        page: 1,
        pageCount: 0,
        count: 0,
      },
      config: {},
      selectedGroup: '0',
      groups: [],
      showGroupDropdown: false,
      replyOrder: 'normal',
      isFieldControlRunning: false,
      showCommandModal: false,
      showImageModal: false,
      showVariableModal: false,
      editingCommand: null,
      newGroupName: '',
      currentCommand: {
        command: '',
        content: '',
      },

      variableContent: '',
      variables: [
        '{商品名称}',
        '{商品价格}',
        '{商品库存}',
        '{关注数量}',
        '{粉丝名称}'
      ],
      commands: []
    }
  },
  watch: {
    selectedGroup(group_id) {

      this.getControlList();
    }
  },
  computed: {

    getSelectedGroupName() {
      if (this.config.group_id == 0) {
        return '默认场控组'
      }
      const group = this.groups.find(g => g.id === this.config.group_id)
      return group ? group.name : '默认场控组'
    },
    apiKey(){
      return this.$store.state.apiKey;
    }

  },
  async mounted() {
    await this.getGroup();
    await this.getConfig();
    await this.getControlList();

    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {

    async getConfig() {
      const res = await http.post("api/field_control/getConfig", {type: "text"});
      this.config = res.data;
    },
    async getControlList() {
      this.queryForm.group_id = this.config.group_id;
      const res = await http.post("api/field_control/textControlList", this.queryForm);
      this.commands = res.data;
      this.queryForm.pageCount = res.data.pageCount
      this.queryForm.count = res.data.count

    },

    async getGroup() {
      const res = await http.get("api/field_control/getGroup");
      this.groups = res.data
    },
    async updateConfigControl(refresh = false, tips = true) {
      const res = await this.updateConfig(tips);
      if (refresh) {
        this.getControlList();
      }

    },
    async updateConfig(tips = true) {
      const res = await http.post("api/field_control/updateConfig", this.config);
      if (tips) {
        if (res.code == 200) {
          this.$dialog.tips({
            message: res.msg,
            type: "success"
          })
        } else {
          this.$dialog.tips({
            message: res.msg,
            type: "error"
          })
        }
      }

      return res;
    },

    async startTextControl() {
      const config = this.config;
      const timer = getRandomInt(config.send_freq_min, config.send_freq_max) * 1000
      if (this.$store.state.textStatus) {
        const res = await http.post("api/auto/autoText", {index: this.$store.state.textIndex})
        if (res.code == 200){
          this.$store.commit("setTextIndex", this.$store.state.textIndex + 1)

        }
        await delay(timer);
        this.startTextControl();
      }

    },
    async toggleFieldControl() {
      this.$store.commit("setTextStatus", !this.$store.state.textStatus)

      if (this.$store.state.textStatus) {
        this.$dialog.tips({
          message: "文字场控已开启",
          type: "success"
        })
        this.startTextControl()
      } else {
        this.$dialog.tips({
          message: "文字场控已关闭",
          type: "success"
        })

      }


    },
    async applyVariables() {

      if (!this.apiKey) {
        this.$dialog.tips({
          type: "error",
          message: "未对接API,请在直播管理右侧->更多服务->API对接中配置API"
        })
        return;

      }
      let content = this.currentCommand.content
      this.$dialog.loading({text: "增加变量中，请稍等..."})
      this.$store.commit("setMessageList",[]);
      console.log(this.$store.state.appids.var_id+"\n5.每组变量包含【】以外的文字和字符组成一句话 不能超过48字");
      const result = await chat(this.$store.state.appids.var_id, this.apiKey, content).catch((message)=>{
        this.$dialog.closeLoading();
        this.$dialog.alert({
          title:"温馨提示",
          message
        })
      });
      this.$dialog.closeLoading();

      if (result) {
        this.variableContent = result
        this.$dialog.tips({
          message: `已为您提供变量`
        })
      }


    },

    insertVariableFromModal(varText) {
      this.currentCommand.content += varText
      this.showVariableModal = false
    },
    addCommand() {
      this.editingCommand = null
      this.variableContent = "",
          this.currentCommand = {
            command: '',
            content: '',
          }
      this.showCommandModal = true
    },
    editCommand(command) {
      this.editingCommand = command
      this.currentCommand = {...command}
      this.variableContent = command.var_content;
      this.showCommandModal = true
    },
    async saveCommand() {
      const contentToSave = this.variableContent || this.currentCommand.content
      if (!contentToSave) return

      if (this.editingCommand) {
        this.editingCommand.content = contentToSave

        const res = await http.post("api/field_control/updateTextControl", {
          id: this.editingCommand.id,
          content: this.currentCommand.content,
          var_content: this.variableContent,
        });

        if (res.code == 200) {
          this.showCommandModal = false
          this.variableContent = ''
          this.$dialog.tips({message: res.msg, type: "success"});
          this.getControlList();
          return;
        }
        this.$dialog.tips({message: res.msg, type: "error"});


      } else {
        const res = await http.post("api/field_control/addTextControl", {
          group_id: this.config.group_id,
          content: this.currentCommand.content,
          var_content: this.variableContent,
        });

        if (res.code == 200) {
          this.showCommandModal = false
          this.variableContent = ''
          this.$dialog.tips({message: res.msg, type: "success"});
          this.getControlList();
          return;
        }
        this.$dialog.tips({message: res.msg, type: "error"});
      }

    },
    async deleteCommand(id) {

      const confirm = await this.$dialog.confirm({
        title: '确认删除',
        message: '确定要删除？删除后将无法恢复。',
        okText: '删除',
        cancelText: '取消'
      }).catch(() => false)

      if (confirm !== false) {
        const res = await http.post("api/field_control/delControl", {type: "text", id})

        if (res.code == 200) {
          this.getControlList();
          this.$dialog.tips({
            message: res.msg,
            type: "success"
          })

          return;
        }
        this.$dialog.tips({
          message: res.msg,
          type: "error"
        })


      }


    },

    async saveGroupWithImage() {
      if (!this.newGroupName) {
        this.$dialog.tips({
          message: "请输入场控组名称",
          type: "error"
        });
        return
      }

      const res = await http.post("api/field_control/addGroup", {name: this.newGroupName})

      if (res.code == 200) {
        this.getGroup();

        this.config.group_id = parseInt(res.data);
        this.updateConfigControl(true, false)
        this.$dialog.tips({message: res.msg, type: "success"})
        this.newGroupName = ''
        this.showImageModal = false
        return;
      }


      this.$dialog.tips({message: res.msg, type: "error"})


    },


    toggleGroupDropdown() {
      this.showGroupDropdown = !this.showGroupDropdown
    },

    handleClickOutside(event) {
      const customSelect = event.target.closest('.custom-select')
      if (!customSelect) {
        this.showGroupDropdown = false
      }
    },

    selectGroup(groupId) {
      this.config.group_id = groupId
      this.showGroupDropdown = false
      this.updateConfigControl(true)
    },

    async deleteGroup(groupId) {
      const confirm = await this.$dialog.confirm({
        title: '确认删除',
        message: '确定要删除这个场控组吗？删除后将无法恢复。',
        okText: '删除',
        cancelText: '取消'
      }).catch(() => false)

      if (confirm !== false) {
        const res = await http.post("api/field_control/deleteGroup", {id: groupId})
        if (res.code == 200) {
          this.$dialog.tips({message: res.msg, type: "success"})
          await this.getGroup()
          if (this.config.group_id === groupId) {
            this.config.group_id = 0
            this.updateConfigControl(true, false)

          }
        } else {
          this.$dialog.tips({message: res.msg, type: "error"})
        }
      }
    },

    importCommands() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.txt'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload = async (event) => {
            try {
              const text = event.target.result;
              console.log(text)
              const res = await http.post("api/field_control/batchImport", {
                type: "text",
                group_id: this.config.group_id,
                contents: text
              })

              if (res.code == 200) {

                this.getControlList();
                this.$dialog.tips({
                  message: res.msg,
                  type: "success"
                })

                return;
              }

              this.$dialog.tips({
                message: res.msg,
                type: "error"
              })

            } catch (error) {
              this.$dialog.tips({
                message: "导入失败：文件解析错误",
                type: "success"
              })
            }
          }
          reader.readAsText(file)
        }
      }
      input.click()
    },
    async exportCommands() {

      const res = await http.post("api/field_control/export", {type: "text", group_id: this.config.group_id});

      if (res.code == 200) {
        const dataBlob = new Blob([res.data.text], {type: 'text/plain'})
        const url = URL.createObjectURL(dataBlob)
        const link = document.createElement('a')
        link.href = url
        link.download = res.data.title;
        link.click()
        URL.revokeObjectURL(url)
      }


    },
    async clearCommands() {

      const confirm = await this.$dialog.confirm({
        title: '温馨提示',
        message: '确定要清空所有场控内容吗',
      }).catch(() => false)

      console.log(confirm)
      if (confirm !== false) {
        const res = await http.post("api/field_control/clearControl", {type: 'text', group_id: this.config.group_id})
        if (res.code == 200) {
          this.getControlList();
          this.$dialog.tips({
            message: res.msg,
            type: "success"
          })
          return;
        }
        this.$dialog.tips({
          message: res.msg,
          type: "error"
        })
      }

    },

    previousPage() {

      if (this.queryForm.page > 1) {
        this.queryForm.page--
        this.getControlList();
      }
    },
    nextPage() {
      if (this.queryForm.page < this.queryForm.pageCount) {
        this.queryForm.page++
        this.getControlList();

      }
    }

  }


}
</script>

<style scoped lang="less">
.field-control {
  display: flex;
  flex-direction: column;
  gap: 20px;
}


.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
  overflow: hidden;
}


.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.control-settings {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.1);
}

.setting-row {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  align-items: center;
}

.setting-row:last-child {
  margin-bottom: 0;
}

.setting-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.setting-item label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);

}

.setting-select {
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  font-size: 14px;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  min-width: 150px;
  transition: all 0.3s ease;
}

.setting-select:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.1);
}

.custom-select {
  position: relative;
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  font-size: 14px;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.custom-select:hover {
  border-color: rgba(170, 170, 170, 0.5);
}

.custom-select:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 0 3px rgba(170, 170, 170, 0.1);
}

.custom-select-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-arrow {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.6);
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.custom-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(35, 35, 35, 0.98);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  z-index: 100;
  overflow: hidden;
}

.dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dropdown-item:hover {
  background: rgba(170, 170, 170, 0.1);
}

.dropdown-item.selected {
  background: rgba(139, 92, 246, 0.2);
  color: #c4b5fd;
}

.group-item {
  justify-content: space-between;
}

.group-item span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delete-group-btn {
  background: none;
  border: none;
  color: rgba(239, 68, 68, 0.6);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  opacity: 0;
}

.group-item:hover .delete-group-btn {
  opacity: 1;
}

.delete-group-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.frequency-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.frequency-input {
  width: 60px;
  padding: 8px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  text-align: center;
  background: rgba(50, 50, 50, 0.8);
  color: rgba(170, 170, 170, 0.9);
  transition: all 0.3s ease;
}

.frequency-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
}

.frequency-separator {
  color: rgba(170, 170, 170, 0.7);
}

.frequency-unit {
  color: rgba(170, 170, 170, 0.7);
  font-size: 14px;
}

.checkbox-group {
  display: flex;
  gap: 25px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
  padding: 10px 16px;
  background: rgba(170, 170, 170, 0.1);
  border-radius: 10px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item:hover {
  background: rgba(170, 170, 170, 0.2);
  border-color: rgba(170, 170, 170, 0.5);
  color: #e0e0e0;
}

.checkbox-item input[type="checkbox"] {
  display: none;
}

.checkbox-item .checkbox-custom {
  width: 44px;
  height: 24px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  border-radius: 12px;
  position: relative;
  border: 1px solid rgba(139, 92, 246, 0.3);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item .checkbox-custom::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  border-radius: 50%;
  top: 1px;
  left: 1px;
  box-shadow: 0 3px 8px rgba(139, 92, 246, 0.4);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(34, 211, 238, 0.5) 100%);
}

.checkbox-item input[type="checkbox"]:checked + .checkbox-custom::before {
  left: 21px;
  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
  box-shadow: 0 3px 8px rgba(255, 255, 255, 0.3);
}

.checkbox-item input[type="checkbox"]:hover {
  transform: scale(1.1);
}

.search-section {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-input {
  flex: 1;
  padding: 12px 15px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  font-size: 14px;
  background: rgba(50, 50, 50, 0.8);
  color: #ccc;
}

.commands-list {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.1);
}

.list-header {
  display: grid;
  grid-template-columns: 50px 460px 1fr 100px;
  gap: 10px;
  padding: 15px 20px;
  background: rgba(60, 60, 60, 0.6);
  font-weight: 600;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  border-bottom: 1px solid rgba(170, 170, 170, 0.3);
}

.header-actions {
  justify-self: end;
}

.command-item {
  display: grid;
  grid-template-columns: 50px 460px 1fr  60px;
  gap: 10px;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.15);
  transition: all 0.3s ease;
  color: #aaa;
}

.item-actions {
  justify-self: end;
  width: 100px;
}

.command-item:hover {
  background: rgba(170, 170, 170, 0.1);
}

.command-item:last-child {
  border-bottom: none;
}

.item-checkbox,
.header-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-command {
  font-weight: 600;
  color: #ccc;
}

.item-content {
  color: #aaa;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-status {
  padding: 4px 12px;
  border-radius: 12px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-status.enabled {
  background: #666;
  color: #eee;
}

.btn-status.disabled {
  background: #444;
  color: #888;
}

.item-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  background: rgba(170, 170, 170, 0.1);
}

.btn-action.edit {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.4) 0%, rgba(37, 99, 235, 0.4) 100%);
  color: #93c5fd;
  border-color: rgba(147, 197, 253, 0.4);
}

.btn-action.edit:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.5) 0%, rgba(37, 99, 235, 0.5) 100%);
  color: #bfdbfe;
  border-color: rgba(147, 197, 253, 0.6);
}

.btn-action.delete {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.4) 0%, rgba(220, 38, 38, 0.4) 100%);
  color: #fca5a5;
  border-color: rgba(248, 113, 113, 0.4);
}

.btn-action.delete:hover {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.5) 0%, rgba(220, 38, 38, 0.5) 100%);
  color: #fecaca;
  border-color: rgba(248, 113, 113, 0.6);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
  opacity: 0.5;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-top: 1px solid rgba(60, 60, 60, 0.5);
}

.pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid rgba(139, 92, 246, 0.3);
  background: rgba(139, 92, 246, 0.1);
  color: #a78bfa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.page-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #8b5cf6 0%, #22d3ee 100%);
  color: #fff;
  border-color: #8b5cf6;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: rgba(170, 170, 170, 0.8);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.98) 0%, rgba(35, 35, 35, 0.98) 100%);
  border-radius: 16px;
  width: 90%;
  max-width: 550px;
  box-shadow: 0 20px 60px rgba(170, 170, 170, 0.1);
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.25);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: rgba(170, 170, 170, 0.9);
}

.close-modal {
  background: rgba(170, 170, 170, 0.2);
  border: 1px solid rgba(170, 170, 170, 0.4);
  font-size: 24px;
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
  line-height: 1;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-modal:hover {
  background: rgba(170, 170, 170, 0.3);
  color: #e0e0e0;
}

.modal-body {
  padding: 20px;
}

.variable-section {
  margin-top: 10px;
}

.variable-section label {
  display: block;

  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
}

.no-resize {
  resize: none;
}

.variable-display {
  width: 100%;
  min-height: 80px;
  padding: 10px;
  border: 1px solid rgba(170, 170, 170, 0.4);
  border-radius: 8px;
  background: rgba(30, 30, 30, 0.9);
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  margin-bottom: 10px;
  resize: vertical;
}

.variable-tools {
  margin-top: 12px;
  border-radius: 10px;
}

.btn-variable-main {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, rgba(100, 100, 100, 0.5) 0%, rgba(80, 80, 80, 0.5) 100%);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 8px;
  color: #c4b5fd;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-variable-main:hover {
  background: linear-gradient(135deg, rgba(120, 120, 120, 0.6) 0%, rgba(100, 100, 100, 0.6) 100%);
  border-color: rgba(170, 170, 170, 0.5);
}

.btn-variable-main i {
  font-size: 16px;
  color: #c4b5fd;
}

.timed-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 15px;
  background: rgba(170, 170, 170, 0.15);
  border-radius: 8px;
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.timed-label {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 500;
}

.switch-mini {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  vertical-align: middle;
}

.switch-checkbox {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(80, 80, 80, 0.6) 0%, rgba(50, 50, 50, 0.6) 100%);
  transition: 0.3s;
  border-radius: 24px;
  border: 1px solid rgba(100, 100, 100, 0.5);
}

.switch-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  top: 50%;
  transform: translate(0%, -50%);
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  transition: 0.3s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.switch-checkbox:checked + .switch-slider {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(99, 102, 241, 0.6) 100%);
  border-color: rgba(167, 139, 250, 0.6);
}

.switch-checkbox:checked + .switch-slider:before {
  transform: translate(20px, -50%);

  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
}

.timed-input-group {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: rgba(170, 170, 170, 0.15);
  border-radius: 6px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  transition: all 0.3s ease;
}

.timed-input-group.active {
  background: rgba(170, 170, 170, 0.25);
  border-color: rgba(170, 170, 170, 0.5);
}

.timed-input {
  width: 45px;
  padding: 4px;
  border: none;
  background: transparent;
  font-size: 13px;
  text-align: center;
  color: rgba(170, 170, 170, 0.9);
}

.timed-input:focus {
  outline: none;
}

.timed-suffix {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.7);
}

.variable-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.btn-variable {
  padding: 4px 12px;
  font-size: 12px;
  background: rgba(80, 80, 80, 0.3);
  border: 1px solid rgba(100, 100, 100, 0.4);
  border-radius: 4px;
  color: #aaa;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-variable:hover {
  background: rgba(100, 100, 100, 0.4);
}

.modal-sm {
  max-width: 400px;
}

.variable-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-variable-item {
  width: 100%;
  padding: 10px 15px;
  font-size: 14px;
  background: rgba(60, 60, 60, 0.8);
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  color: #aaa;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.btn-variable-item:hover {
  background: rgba(80, 80, 80, 0.6);
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  font-weight: 600;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(170, 170, 170, 0.4);
  border-radius: 8px;
  font-size: 14px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  box-sizing: border-box;
}

.form-textarea {
  resize: vertical;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: normal;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid rgba(170, 170, 170, 0.25);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(139, 92, 246, 0.2);
  transition: left 0.3s ease;
  z-index: -1;
}

.btn:hover::before {
  left: 0;
}

.btn-primary {
  background: linear-gradient(135deg, rgba(100, 100, 100, 0.7) 0%, rgba(80, 80, 80, 0.7) 100%);
  color: rgba(170, 170, 170, 0.9);
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.15);
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.btn-import {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.7) 0%, rgba(37, 99, 235, 0.7) 100%);
  color: #ffffff;
  border: 1px solid rgba(147, 197, 253, 0.5);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-import:hover {
  background: linear-gradient(135deg, rgba(147, 197, 253, 0.7) 0%, rgba(59, 130, 246, 0.7) 100%);
}

.btn-export {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.7) 0%, rgba(22, 163, 74, 0.7) 100%);
  color: #ffffff;
  border: 1px solid rgba(74, 222, 128, 0.5);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
}

.btn-export:hover {
  background: linear-gradient(135deg, rgba(74, 222, 128, 0.7) 0%, rgba(34, 197, 94, 0.7) 100%);
}

.btn-field-control {
  background: linear-gradient(135deg, rgba(249, 115, 22, 0.7) 0%, rgba(234, 88, 12, 0.7) 100%);
  color: #ffffff;
  border: 1px solid rgba(251, 146, 60, 0.5);
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
}

.btn-field-control:hover {
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.7) 0%, rgba(249, 115, 22, 0.7) 100%);
}

.btn-field-control-active {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.7) 0%, rgba(220, 38, 38, 0.7) 100%) !important;
  border-color: rgba(248, 113, 113, 0.5) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.btn-sm {
  padding: 8px 12px;
  font-size: 14px;
}

.btn-search {
  background: rgba(80, 80, 80, 0.3);
  color: #aaa;
  border: 1px solid rgba(100, 100, 100, 0.3);
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(100, 100, 100, 0.4);
}

@media (max-width: 1200px) {
  .setting-row {
    flex-wrap: wrap;
  }

  .list-header,
  .command-item {
    grid-template-columns: 50px 80px 1fr 80px 80px;
  }
}

@media (max-width: 768px) {
  .header-actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .setting-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .list-header,
  .command-item {
    grid-template-columns: 40px 1fr;
    gap: 10px;
  }

  .list-header > div:not(:nth-child(1)):not(:nth-child(2)),
  .command-item > div:not(:nth-child(1)):not(:nth-child(2)) {
    display: none;
  }
}

</style>
